import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import UnveilingYourRadiance from "./sections/UnveilingYourRadiance";
import TheArtOfTheGlow from "./sections/TheArtOfTheGlow";
import TransformationSpotlight from "./sections/TransformationSpotlight";
import CuratedBeautyServices from "./sections/CuratedBeautyServices";
import VoicesOfBeauty from "./sections/VoicesOfBeauty";
import BeginYourJourney from "./sections/BeginYourJourney";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <UnveilingYourRadiance />
      <TheArtOfTheGlow />
      <TransformationSpotlight />
      <CuratedBeautyServices />
      <VoicesOfBeauty />
      <BeginYourJourney />
      <Footer />
    </div>;
}